import { type SortDirection } from "@tanstack/react-table"
import { BaseButton } from "@tokenterminal/core/ui/button/Button"
import {
  MenuButton,
  type MenuButtonProps,
} from "@tokenterminal/core/ui/menu/MenuButton"
import SortableHeader from "@tokenterminal/core/ui/table/SortableHeader"

import { type LegacyRef, useRef } from "react"
import { leftAlignedColumns } from "./Table"

export const HeaderActionButton = ({
  actions,
  sortDirection,
  header,
}: {
  actions: MenuButtonProps<object>["children"]
  sortDirection: SortDirection | undefined
  header: any
}) => {
  const ref: LegacyRef<HTMLButtonElement> | undefined = useRef(null)
  const column = header.column.columnDef
  const isGrouped = column.group && column.group !== column.header
  const isLeftAligned = leftAlignedColumns.includes(header.id)

  const title = isGrouped ? column.group : column.header
  const subtitle = isGrouped ? column.header : undefined

  const Trigger = () => (
    <SortableHeader
      onPress={(e) => {
        if (e.shiftKey) {
          if (sortDirection === "desc") {
            header.column.toggleSorting(false)
          } else {
            header.column.toggleSorting(true)
          }
        } else {
          ref.current?.click()
        }
      }}
      title={
        <span className={!!sortDirection ? "text-fg-default" : undefined}>
          {title}
        </span>
      }
      subtitle={subtitle}
      isActiveSort={!!sortDirection}
      sortDirection={sortDirection as SortDirection}
      alignment={isLeftAligned ? "left" : "right"}
      style={{
        height: "48px",
      }}
    />
  )

  return (
    <div className="relative">
      <Trigger />
      <MenuButton
        trigger={
          <BaseButton
            ref={ref}
            excludeFromTabOrder
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              opacity: 0,
            }}
          />
        }
      >
        {actions}
      </MenuButton>
    </div>
  )
}
